import { useAppDispatch } from '@hooks/reduxHooks'
import { Box, Button, Input, InputAdornment, Tooltip } from '@mui/material'
import { setDoctorFilters } from '@state/reducers/doctorReducer'
import { useIntl } from 'react-intl'
import { debounce } from 'lodash'
import { useMemo } from 'react'
import PlusIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search'
import RppsLogo from '@assets/img/logos/rpps.png'
type Props = {
  onAddClick: () => void
  hideActions: boolean
}
const DoctorToolbar: React.FC<Props> = ({ onAddClick, hideActions }) => {
  const dispatch = useAppDispatch()
  const intl = useIntl()

  const onSearchChange = useMemo(
    () =>
      debounce((searchTerm: string) => {
        dispatch(setDoctorFilters({ search: searchTerm }))
      }, 300),
    [],
  )

  return (
    <div className="flex items-center justify-between gap-x-3 mb-2">
      <Input
        onChange={(ev) => {
          onSearchChange(ev.target.value)
        }}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        }
        placeholder={intl.formatMessage({
          id: 'labels.searchDoctor',
        })}
        style={{
          height: '40px',
          width: '59%',
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: '5px',
          padding: '0 10px',
        }}
        disableUnderline
      />

      {!hideActions && (
        <Tooltip title="Ajouter à partir de la base RPPS complète" arrow>
          <Button
            onClick={onAddClick}
            variant="outlined"
            color="primary"
            startIcon={<PlusIcon />}
            sx={{
              p:'0px 8px'
            }}
            endIcon={
              <Box
                sx={{
                  width: 84,
                  height: 44,
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center',
                  pt:1
                }}
              >
                <img
                  src={RppsLogo}
                  alt="RPPS"
                  style={{
                    height: 120,
                    objectFit: 'cover',
                    objectPosition: '0px',
                  }}
                />
              </Box>
            }
          >
            {intl.formatMessage({ id: 'add' })}
          </Button>
        </Tooltip>
      )}
    </div>
  )
}

export default DoctorToolbar
